import { Product, ProductComponent } from '../../types';
import { getSubComponentTotal } from './getSubComponentTotal';
import  Decimal  from 'decimal.js';

export function getSubComponentsTotal(productComponent: ProductComponent, components: ProductComponent[]) : number {
    const componentTotals = productComponent.components.reduce((acc, component) => acc.add(getSubComponentTotal(component, components)), new Decimal(0));
    return componentTotals.toNumber()
}   